export const pageGuides = {
  build: {
    name: 'Process Map', prompt: 'Help me choose the next step for building or improving a process here.',
  },
  views: {
    name: 'Apps', prompt: 'Explain this app, the data it uses, and what I can do here.',
  },
  'ontology-data': {
    name: 'Data', prompt: 'Help me understand the records and relationships on this data page.',
  },
  'initiatives': {
    name: 'Agents', prompt: 'Explain what this initiative is doing and the next action it needs from me.',
  },
  automations: {
    name: 'Automations', prompt: 'Help me understand this automation and how to check when it runs and what it changes.',
  },
  integrations: {
    name: 'Integrations', prompt: 'Help me connect a business system. Explain the access and setup information needed first.',
  },
  mcp: {
    name: 'AI connections', prompt: 'Help me connect my AI assistant to this workspace and choose a first question to try.',
  },
};
pageGuides['operations-map'] = pageGuides.build;

export const defaultGuide = {
  name: 'this page', prompt: 'Explain this page and help me take the next useful step.',
};

